"use client";
import { IBlocks, IUserData } from "@/types";
import React from "react";
import { cn, rgbToHex } from "@/lib/utils";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { IconTerminal } from "@tabler/icons-react";
import AdminPopover from "./utils/AdminPopover";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import BlockClickHandler from "./utils/click";
import { BORDER_RADIUS_OPTIONS } from "./utils/block-style-classes";

interface Props {
    edit?: boolean;
    account: IUserData;
    block: IBlocks;
    update?: BlockUpdateFunction;
    theme: IUserData["chosen_theme"];
}
export default function BlockGithubUser({
    edit,
    account,
    block,
    update,
    theme,
}: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    let hide: string = "";
    if (!blockUpdate.options.stars) {
        hide += "stars,";
    }
    if (!blockUpdate.options.prs) {
        hide += "prs,";
    }
    if (!blockUpdate.options.issues) {
        hide += "issues,";
    }
    if (!blockUpdate.options.contribs) {
        hide += "contribs,";
    }
    let TextColour = rgbToHex(theme.profile.colors.primary_text).replace(
        "#",
        ""
    );
    let backgroundColor = rgbToHex(theme.profile.colors.primary).replace(
        "#",
        ""
    );
    let borderColor = rgbToHex(theme.profile.colors.tertiary).replace("#", "");
    let borderRadius =
        BORDER_RADIUS_OPTIONS[theme.profile.design.corner_radius].remValue;
    if (blockUpdate.style?.custom) {
        backgroundColor = rgbToHex(blockUpdate.style.colors.primary).replace(
            "#",
            ""
        );
        TextColour = rgbToHex(blockUpdate.style.colors.primary_text).replace(
            "#",
            ""
        );
        borderColor = rgbToHex(blockUpdate.style.colors.border).replace(
            "#",
            ""
        );
        borderRadius =
            BORDER_RADIUS_OPTIONS[blockUpdate.style.corner_radius].remValue;
    }
    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={`Github User - ${blockUpdate.url}`}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            {blockUpdate.url === "" ? (
                edit ? (
                    <Alert>
                        <IconTerminal
                            color="white"
                            className="text-copy h-4 w-4"
                        />
                        <AlertTitle>Oops!</AlertTitle>
                        <AlertDescription>
                            You've not added a username yet! This block will not
                            show anything until you do.
                        </AlertDescription>
                    </Alert>
                ) : null
            ) : (
                <a
                    href={"https://github.com/" + blockUpdate.url}
                    target="_blank"
                    className={cn("w-full", "block-" + block.id)}
                    onClick={(e) => {
                        BlockClickHandler(account, e, block, edit);
                    }}
                    onAuxClick={(e) => {
                        BlockClickHandler(account, e, block, edit);
                    }}
                >
                    <img
                        id="github"
                        loading="lazy"
                        style={{
                            borderRadius: borderRadius,
                        }}
                        width="100%"
                        alt="GitHub Statistics Card"
                        src={`https://github-stats.doras.to/?username=${
                            blockUpdate.url
                        }&theme=dark&show_icons=true&bg_color=${backgroundColor}&text_color=${TextColour}&icon_color=${TextColour}&title_color=${TextColour}&border_color=${borderColor}&hide_border=${borderColor === "rgba(0, 0, 0, 0)"}&border_radius=${borderRadius}&hide_rank=${!blockUpdate.options?.rank}&hide=${hide}`}
                        data-border={borderColor}
                        data-text={TextColour}
                        data-background={backgroundColor}
                        data-radius={borderRadius}
                    />
                </a>
            )}
        </AdminPopover>
    );
}
